//jsxhook

import React, { MutableRefObject } from "react"
import { useCartState } from "../cart/CartServiceHook"
import { NetgiroConfig } from "./NetgiroConfig"

export interface FramesProps {
  formRef: MutableRefObject<HTMLFormElement | null>
  applicationIdRef: MutableRefObject<HTMLInputElement | null>
  signatureRef: MutableRefObject<HTMLInputElement | null>
  totalAmountRef: MutableRefObject<HTMLInputElement | null>
  referenceNumberRef: MutableRefObject<HTMLInputElement | null>
  paymentSuccessfulURLRef: MutableRefObject<HTMLInputElement | null>
}

export const NetGiroFrame: React.FC<FramesProps> = props => {
  const netgiroURL = NetgiroConfig.netgiroUrl

  return (
    <form action={netgiroURL} method="POST" ref={props.formRef}>
      <input type="hidden" name="Iframe" value="false" />
      <input type="hidden" name="ApplicationID" ref={props.applicationIdRef} />
      <input type="hidden" name="Signature" ref={props.signatureRef} />
      <input type="hidden" name="TotalAmount" ref={props.totalAmountRef} />
      <input
        type="hidden"
        name="ReferenceNumber"
        ref={props.referenceNumberRef}
      />
      <input
        type="hidden"
        name="PaymentSuccessfulURL"
        ref={props.paymentSuccessfulURLRef}
      />
      <input type="submit" sx={{ display: "none" }} />
    </form>
  )
}
